import { z } from 'zod'
import { ContentfulAssetSchema } from './asset'

export const ContentfulStaticAssetSchema = z.object({
  identifier: z.string().optional(),
  asset: ContentfulAssetSchema,
})

export type ContentfulStaticAsset = z.infer<typeof ContentfulStaticAssetSchema>
